import React from "react";

import clsx from "clsx";
import { useFormContext } from "react-hook-form";

import { getErrorTypeText } from "./getErrorTypeText";
import { getByPath } from "../../../utils/getByPatth";

interface FormTextFieldProps extends React.HTMLProps<HTMLInputElement> {
  fullWidth?: boolean;
  small?: boolean;
  label?: string;
  containerClassName?: string;
  endAdornment?: React.ReactNode;
}

export const FormTextField = React.forwardRef<any, FormTextFieldProps>(
  (
    {
      fullWidth = false,
      className,
      small = false,
      label,
      disabled,
      name,
      containerClassName,
      endAdornment,
      ...rest
    },
    ref
  ) => {
    const {
      formState: { errors },
    } = useFormContext();

    const errorKey = name as string;
    const extractedError = getByPath(errorKey, errors);

    const getErrorText = () => {
      if (extractedError) {
        if (extractedError?.message) {
          return extractedError?.message as string;
        } else {
          if (label) {
            return `${label} is ${getErrorTypeText(
              extractedError?.type as string
            )}`;
          } else {
            return `${name} is ${getErrorTypeText(
              extractedError?.type as string
            )}`;
          }
        }
      } else {
        return `${label} is ${getErrorTypeText(
          errors[errorKey]?.type as string
        )}`;
      }
    };

    return (
      <div className={clsx("flex flex-col space-y-1", containerClassName)}>
        {label && (
          <label className="text-sm text-black font-medium opacity-80">
            {label}
          </label>
        )}
        <div className="relative">
          <input
            className={clsx(
              "rounded border outline-none focus:drop-shadow-none focus:ring-2 !border-secondary focus:ring-secondary",
              fullWidth && "w-full",
              disabled
                ? "bg-gray-200 text-gray-800 cursor-not-allowed"
                : "bg-white text-black ",
              small ? "px-1 py-0.5" : "px-3 py-2",
              endAdornment && "pr-10",
              className,
              extractedError && "!border-red-600 focus:!ring-red-600"
            )}
            disabled={disabled}
            ref={ref}
            name={name}
            aria-label={label}
            {...rest}
          />
          {endAdornment && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
              {endAdornment}
            </div>
          )}
        </div>
        {extractedError && (
          <p className="text-xs text-red-500">{getErrorText()}</p>
        )}
      </div>
    );
  }
);
